import { Injectable } from "@nestjs/common";
import { EntityRepository, Raw, Repository } from "typeorm";
import { PoItems } from "../po-creation-items.entity";
@Injectable()
@EntityRepository(PoItems)
export class PoItemsRepository extends Repository<PoItems>{
    async getReceivedQty(){
        // const poItemEntity = this.createQueryBuilder("PoItems")
       
        // // const plieDetails = await this.createQueryBuilder('purchase_order')
        // //     .select('purchase_order_id,vendor_name,total_quantity,total_basic_price,total_discount,total_tax,total_cost')
        // //     .leftJoin('purchase_order.purchase_order_id', 'purchase_order_items')
        //     .where(` PoItems.purchaseOrderId= '${poId}' and itemCategory =  `)
        //     .getOne();
        //     // console.log(poEntity)
        // return poEntity ;

    }

   
    async updateReceivedQty(recQty:number,acceptedQty:number,itemId:number,poId:number,saleOrderId:number,itemCategoryId:number,manager){
        try {

            const updatedRecQty = Number(recQty)+Number(acceptedQty);
            const updatedPo =  await manager.getRepository(PoItems).update({purchaseOrderId:poId,itemName:itemId,saleOrderId:saleOrderId},{ receivedQuantity: updatedRecQty} );
            return updatedPo;
        } catch (err) {
            throw err;
        }

    }
}